/* eslint-disable camelcase */
import { GetInitialStateInner } from 'Jsx/Utils/getBaseInitialState';

import { AppProps } from './types';

// @ts-expect-error
const getInitialState: GetInitialStateInner<AppProps> = ({
  // @ts-expect-error
  contentLanding,
}) => {
  return {
    contentLanding: contentLanding?.content_landing,
    contentLandingItems: contentLanding?.content_landing_items,
    contentLandingHighlights: contentLanding?.content_landing_items_highlight,
    course: contentLanding?.course,
    filters: contentLanding?.content_landing_categories,
  };
};

export default getInitialState;
